import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as feather from 'feather-icons';
import { LayoutService } from '../../../services/layout.service';
import { NavService } from '../../../services/nav.service';
import { fadeInAnimation } from '../../../data/router-animation/router-animation';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../../utils/authentication.service';
import { LocalStorageService } from '../../../../utils/local-storage.service';
import constant from '../../../../app.constant';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  animations: [fadeInAnimation]
})
export class ContentComponent implements OnInit, AfterViewInit {

  constructor(public navServices: NavService, public authService: AuthenticationService,
    public layout: LayoutService, private activatedRoute: ActivatedRoute, private localStorage: LocalStorageService,) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  ngOnInit() {
    // this.activatedRoute.queryParams.subscribe(async params => {
    //   const token: any = params['tok'];
    //   if (token) {
    //     this.authService.tokenSetAndCheckInLocalStorage(token);
    //   } else if (!this.localStorage.getItem(constant.localStorage.token)) {
    //     this.authService.logout();
    //   }
    // });

    // if (this.localStorage.getItem(constant.localStorage.token)) {
    // } else {
    //   this.authService.logout();
    // }
  }

}

// ngOnInit() {
//   this.activatedRoute.queryParams.subscribe(async params => {
//     const token: any = params['tok'];
//     if (token) {
//       this.authService.tokenSetAndCheckInLocalStorage(token);
//     } else if (this.localStorage.getItem(constant.localStorage.token)) {
//       //For set menu
//       this.authService.tokenSetAndCheckInLocalStorage(this.localStorage.getItem(constant.localStorage.token));
//     }
//   });
// }